<template>
  <iframe
    ref="iframe"
    class="tw:size-full tw:overflow-hidden tw:border-none"
    :srcdoc="html"
    @load="handleLoad"
  ></iframe>
</template>

<script lang="ts" setup>
import { useTemplateRef } from "vue";

interface Props {
  html: string;
  overflow?: "hidden" | "auto";
}
const props = defineProps<Props>();
const emit = defineEmits(["load"]);

const iframe = useTemplateRef("iframe");
const handleLoad = () => {
  if (iframe.value?.contentDocument) {
    const doc = iframe.value.contentDocument;
    doc.documentElement.style.overflow = props?.overflow || "auto";
    const iframeBody = doc.body;
    iframeBody.style.pointerEvents = "none";
    iframeBody.style.height = "auto";
    iframeBody.style.margin = "0";
    iframeBody.style.textAlign = "center";
    iframeBody.style.width = "100%";

    const mainTable = doc.querySelector("table") || doc.querySelector(".u-body") || doc.querySelector("#u_body");
    if (mainTable) {
      (mainTable as HTMLElement).style.margin = "0 auto";
      (mainTable as HTMLElement).style.display = "table";
      (mainTable as HTMLElement).style.textAlign = "left";
    }

    const allTables = doc.querySelectorAll("table");
    allTables.forEach((table) => {
      if (!table.parentElement || table.parentElement === iframeBody) {
        (table as HTMLElement).style.margin = "0 auto";
        (table as HTMLElement).style.display = "table";
        (table as HTMLElement).style.textAlign = "left";
      }
    });

    emit("load", doc);
  }
};
</script>
